<template>
  <div class="service-monitor-item d-flex align-items-center justify-content-around"
   :class="{'dark':skinType}">
    <div class="d-flex flex-column">
      <div class="name">{{monitorItem.name}}</div>
       <div class="info">
          <span class="info-value">{{monitorItem.value}}</span>
          <span>{{monitorItem.unit}}</span>
       </div>
    </div>
    <div class="icon-container d-flex align-items-center justify-content-center"
    :style="{'backgroundColor': this.iconInfo.backColor}">
      <span class="icon iconfont" :class="iconInfo.icon"
      :style="[
      {'color':this.iconInfo.frontColor}]"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'service-monitor-item',
  props: {
    monitorItem: {
      type: Object,
      default() {
        return {
          name: 'CPU核心数',
          value: 0,
          unit: '',
        };
      },
    },
    iconInfo: {
      type: Object,
      default() {
        return {
          icon: '',
          backColor: '#1D86F4',
          frontColor: '#C6E2FF',
        };
      },
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
};
</script>
<style scoped>
.icon-container{
  width:50px;
  height:50px;
  border-radius: 50%;
}
.icon.iconfont{
  font-size:20px;
}
.service-monitor-item{
  background-color:white;
  width:15rem;
  height:5rem;
  border-radius: 4px;
}
.service-monitor-item.dark{
  background-color:#223388;
}
.info-value{
  font-size: 1.5rem;
  color:#409EFF;
}
</style>
